module.exports = __webpack_public_path__ + "static/apple-touch-icon-114x114-075ac28a6d2c958761408cbc39e684c2.png";